import { useEffect, useState } from 'react';
import { Alert, message } from 'antd';

const WAS_OFFLINE_KEY = 'offline_banner_was_offline';

export const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => {
      setIsOnline(false);
      try {
        sessionStorage.setItem(WAS_OFFLINE_KEY, '1');
      } catch {
        // ignore
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    try {
      if (navigator.onLine && sessionStorage.getItem(WAS_OFFLINE_KEY) === '1') {
        sessionStorage.removeItem(WAS_OFFLINE_KEY);
        message.success(
          'Conexión restablecida. Ya podés usar la aplicación con normalidad.',
          5
        );
      }
    } catch {
      // ignore
    }
  }, []);

  if (isOnline) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        padding: '16px 24px',
        boxSizing: 'border-box',
        backgroundColor: '#ff4d4f',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      }}
    >
      <Alert
        message={
          <span style={{ fontSize: '18px', fontWeight: 700 }}>
            Sin conexión a Internet
          </span>
        }
        description={
          <span style={{ fontSize: '15px', marginTop: 4, display: 'block' }}>
            Revisá tu conexión. Algunas funciones pueden no estar disponibles
            hasta que se restablezca. Recargá la página cuando vuelvas a tener
            conexión.
          </span>
        }
        type="error"
        showIcon
        style={{
          fontSize: '16px',
          padding: '16px 20px',
          alignItems: 'center',
        }}
      />
    </div>
  );
};
